import { GetLuckyWheelResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getLuckyWheel } from '../../services'
import { LuckyWheelQueryKeys } from '@/modules/promotion/keys'

export default function useQueryGetLuckyWheel(
	props?: UseBaseQueryOptions<GetLuckyWheelResponse>,
) {
	return useQuery({
		queryKey: [LuckyWheelQueryKeys.GetLuckyWheel],
		queryFn: () => getLuckyWheel(),
		...props,
	})
}
